/** Alerte Mon matin : familles n'ayant pas encore confirmé leurs 5 actions de rentrée. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export function RentreeActionsCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/rentree/bilan-data").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || !d.config?.deadline) return null;
  const missing = Math.max(0, d.members_active - d.confirmations.complete);
  const pct = d.members_active ? Math.round((d.confirmations.complete / d.members_active) * 100) : 0;
  return (
    <Link to="/app/rencontre-rentree" data-testid="rentree-actions-card" className={`block mb-5 rounded-2xl border p-4 transition-colors ${missing > 0 ? "border-amber-500/40 bg-amber-500/5 hover:bg-amber-500/10" : "border-emerald-500/40 bg-emerald-500/5"}`}>
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-amber-400 font-bold">Rentrée · 5 actions obligatoires</div>
          <div className="text-lg font-bold text-zinc-100" data-testid="rentree-actions-missing">{missing > 0 ? `${missing} famille${missing > 1 ? "s" : ""} n'ont pas encore confirmé leurs 5 actions` : "Toutes les familles ont confirmé leurs 5 actions 🥋"}</div>
          <div className="text-xs text-zinc-400">{d.confirmations.complete}/{d.members_active} complétées ({pct} %) · date limite {d.config.deadline}{d.confirmations.total > d.confirmations.complete ? ` · ${d.confirmations.total - d.confirmations.complete} en cours` : ""}</div>
        </div>
        <div className="w-40 h-2 rounded-full bg-zinc-800 overflow-hidden"><div className="h-full bg-amber-500" style={{ width: `${pct}%` }} /></div>
      </div>
    </Link>
  );
}
